import { getImageUrl } from "Common/utils/ImageDomain";
import DescriptionHtmlCode from "../../Common/Components/HtmlCode/DescriptionHtmlCode";
import ShowOnlyText from "../../Common/Components/HtmlCode/ShowOnlyText";

const AwardSegmentCard = ({
  index,
  award,
  handleRemoveIcon,
  toggle,
  setIndex,
  setEventData,
  isEditable,
  errors,
  handleSegmentInputChange,
  removeSegment,
}) => {
  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
        <div>
          <div className="flex my-4">
            {award?.icon ? (
              <div className="flex items-center">
                <div className="relative w-40 h-40">
                  <img
                    data-dz-thumbnail
                    className="rounded border-[gray] border"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                    src={getImageUrl(award?.icon)}
                    alt={"img"}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "6px",
                      fontSize: "22px",
                      cursor: "pointer",
                    }}
                    onClick={
                      isEditable
                        ? () => {
                            handleRemoveIcon(index);
                          }
                        : null
                    }
                  >
                    ×
                  </span>
                </div>
                <div className="h-3 ml-3">
                  <button
                    onClick={
                      isEditable
                        ? () => {
                            toggle();
                            setIndex(index);
                            setEventData(undefined);
                          }
                        : null
                    }
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={
                  isEditable
                    ? () => {
                        toggle();
                        setIndex(index);
                        setEventData(undefined);
                      }
                    : null
                }
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add imageUrl
              </button>
            )}
          </div>
          {errors.segments[index]?.icon && (
            <p className="text-sm text-red-500">
              {errors.segments[index].icon}
            </p>
          )}
        </div>
        {/* 
                  <label className="inline-block mb-2 text-base font-medium">
                    Image Alt Text
                  </label>
                  <input
                    type="text"
                    value={award}
                    onChange={(e) =>
                      handleSegmentInputChange(
                        index,
                        "description",
                        e.target.value
                      )
                    }
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Sub Header Text"
                  /> */}

        <label className="inline-block mb-2 text-base font-medium">
          Description
        </label>
        {!isEditable ? (
          <ShowOnlyText content={award.description} setContent={""} />
        ) : null}

        {isEditable ? (
          <DescriptionHtmlCode
            content={award.description}
            setContent={(e) =>
              handleSegmentInputChange(index, "description", e)
            }
          />
        ) : null}
        {errors.segments[index]?.description && (
          <p className="text-sm text-red-500">
            {errors.segments[index].description}
          </p>
        )}
        {/* Remove Segment Button */}
        <div className="flex justify-end mt-2">
          <button
            onClick={isEditable ? () => removeSegment(index) : null}
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
          >
            Remove
          </button>
        </div>
      </div>
    </>
  );
};

export default AwardSegmentCard;
